import { motion } from "framer-motion";

export default function LoadingScreen() {
  return (
    <>
      <div className="loading-screen">
        <motion.svg
          height="100%"
          strokeMiterlimit="10"
          version="1.1"
          viewBox="0 0 1024 1024"
          width="100%"
          xmlns="http://www.w3.org/2000/svg"
          initial="hidden"
          animate="visible"
        >
          <motion.path
            className="path"
            d="M512.833 900.081C485.073 900.081 460.506 894.668 439.131 883.842C417.756 873.015 400.961 857.054 388.747 835.956C376.532 814.859 370.425 789.597 370.425 760.172C370.425 752.955 370.703 745.598 371.258 738.103C371.814 730.608 372.647 722.974 373.756 715.201C328.23 717.977 286.036 712.702 247.172 699.378C208.309 686.053 174.441 666.205 145.572 639.834C116.702 613.462 94.2165 581.538 78.1157 544.062C62.0149 506.587 53.9639 465.363 53.9639 420.393C53.9639 379.309 60.9041 340.861 74.7846 305.051C88.6639 269.241 108.651 237.734 134.745 210.529C160.839 183.325 192.346 162.088 229.268 146.821C266.188 131.553 307.134 123.919 352.104 123.919C397.075 123.919 437.881 131.414 474.525 146.405C511.167 161.395 542.536 182.353 568.63 209.28C594.724 236.207 614.85 267.159 629.007 302.136C643.165 337.114 650.244 374.867 650.244 415.396L650.244 751.011C650.244 780.991 644.691 807.225 633.587 829.71C622.484 852.195 606.8 869.545 586.535 881.759C566.27 893.974 541.703 900.081 512.833 900.081ZM507.836 828.461C526.157 828.461 541.147 821.937 552.806 808.891C564.466 795.843 570.296 777.106 570.296 752.677L570.296 554.473C541.98 572.794 519.495 591.393 502.839 610.269C486.184 629.146 473.831 647.467 465.78 665.234C457.73 683 452.455 699.378 449.957 714.368C447.458 729.359 446.209 741.851 446.209 751.844C446.209 767.945 449.124 781.686 454.953 793.067C460.783 804.449 468.417 813.193 477.856 819.301C487.293 825.407 497.287 828.461 507.836 828.461ZM352.104 646.913C360.988 646.913 369.315 646.496 377.087 645.664C384.86 644.831 393.188 643.304 402.072 641.083C409.844 622.206 420.809 603.052 434.967 583.62C449.124 564.188 467.168 544.895 489.099 525.741C511.029 506.587 538.094 488.682 570.296 472.027L570.296 415.396C570.296 383.75 564.883 354.464 554.057 327.537C543.229 300.61 527.962 277.291 508.252 257.582C488.543 237.872 465.363 222.327 438.714 210.945C412.065 199.564 383.195 193.873 352.104 193.873C320.458 193.873 291.449 199.564 265.077 210.945C238.705 222.327 215.665 238.289 195.955 258.831C176.247 279.374 160.978 303.385 150.152 330.868C139.325 358.35 133.912 388.191 133.912 420.393C133.912 452.595 139.325 482.436 150.152 509.918C160.978 537.4 176.247 561.412 195.955 581.955C215.665 602.496 238.705 618.459 265.077 629.84C291.449 641.222 320.458 646.913 352.104 646.913Z"
            fillRule="evenodd"
            opacity="1"
            stroke="#ffffff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="30"
            variants={pathVariants}
          />
          <motion.path
            className="path"
            d="M761.838 716.866L761.838 412.898C761.838 375.145 772.525 345.58 793.9 324.206C815.275 302.83 844.839 292.143 882.592 292.143L970.036 292.143L970.036 357.933L896.75 357.933C878.428 357.933 864.132 363.208 853.861 373.756C843.59 384.306 838.454 399.018 838.454 417.895L838.454 716.866L761.838 716.866Z"
            fillRule="evenodd"
            opacity="1"
            stroke="#ffffff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="30"
            variants={pathVariants}
          />
        </motion.svg>
      </div>
    </>
  );
}

const pathVariants = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    transition: { duration: 2, ease: "easeInOut" },
  },
};
